import '@/utils/bizBrowser'
import store from '@/store'
import { UPDATE_BIZ_BROWSER_STATE } from '@/store/actions'
import { BizBrowserMode } from '@/store/bizBrowser/interface'
import { BizBrowserFunctionNames } from './bizBrowserFunctionNames'

export function isBizSdAvailable(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.bizsd !== 'undefined' &&
    typeof window.bizsd.postMessage === 'function'
  )
}

export const SendToBizBrowser = {
  connectWithScanner(): void {
    this.idleMode()
    const newState = {
      ...store.getters.bizBrowserState,
      mode: BizBrowserMode.CONNECTING_TO_SCANNER,
      modeChangedAt: new Date(),
      isDeviceScanning: false,
    }
    store.dispatch(UPDATE_BIZ_BROWSER_STATE, newState)

    // eslint-disable-next-line no-unused-expressions
    window.bizsd?.postMessage(`${BizBrowserFunctionNames.SEND_STATE}::${JSON.stringify(newState)}`)
  },

  startScan(): void {
    const newState = {
      ...store.getters.bizBrowserState,
      mode: BizBrowserMode.SCANNING,
      modeChangedAt: new Date(),
    }
    store.dispatch(UPDATE_BIZ_BROWSER_STATE, newState)

    // eslint-disable-next-line no-unused-expressions
    window.bizsd?.postMessage(`${BizBrowserFunctionNames.SEND_STATE}::${JSON.stringify(newState)}`)
  },

  idleMode(): void {
    const newState = {
      ...store.getters.bizBrowserState,
      mode: BizBrowserMode.IDLE,
      modeChangedAt: new Date(),
      isDeviceScanning: false,
    }
    store.dispatch(UPDATE_BIZ_BROWSER_STATE, newState)

    // eslint-disable-next-line no-unused-expressions
    window.bizsd?.postMessage(`${BizBrowserFunctionNames.SEND_STATE}::${JSON.stringify(newState)}`)
  },

  updateRfidPowerLevel(powerLevel: number): void {
    const newState = {
      ...store.getters.bizBrowserState,
      rfidPowerLevel: powerLevel,
    }
    store.dispatch(UPDATE_BIZ_BROWSER_STATE, newState)

    // eslint-disable-next-line no-unused-expressions
    window.bizsd?.postMessage(`${BizBrowserFunctionNames.SEND_STATE}::${JSON.stringify(newState)}`)
  },
}
